import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Table, Tag, message } from 'antd';
import { useAuth } from '../../../contexts/AuthContext';

const { Title, Paragraph } = Typography;

const PaymentHistory = () => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const { currentUser, token } = useAuth();

  useEffect(() => {
    const run = async () => {
      if (!currentUser?.id) return;
      setLoading(true);
      try {
        const qs = new URLSearchParams({ limit: '50' });
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await fetch(`/api/invoices/my?${qs.toString()}`, { headers });
        if (!res.ok) throw new Error('Failed to load invoices');
        const data = await res.json();
        const items = Array.isArray(data?.items) ? data.items : [];
        const mapped = items.map((inv) => ({
          id: inv.invoice_no || inv.id,
          date: inv.issued_at,
          amount: inv.amount ?? 0,
          status: inv.status || 'due',
          method: '-',
        }));
        setRows(mapped);
      } catch (e) {
        message.error(e.message || 'Error loading payment history');
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [currentUser, token]);

  const columns = [
    { title: 'Invoice #', dataIndex: 'id', key: 'id' },
    { title: 'Date', dataIndex: 'date', key: 'date' },
    { title: 'Amount', dataIndex: 'amount', key: 'amount', render: v => `$${Number(v || 0).toFixed(2)}` },
    { title: 'Status', dataIndex: 'status', key: 'status', render: s => <Tag color={s === 'paid' ? 'green' : (s === 'overdue' ? 'red' : 'orange')}>{s}</Tag> },
    { title: 'Method', dataIndex: 'method', key: 'method' },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Client' }, { title: 'Billing' }, { title: 'Payment History' }]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Payment History</Title>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>Your recent invoices and payments.</Paragraph>
        <Table rowKey="id" columns={columns} dataSource={rows} loading={loading} pagination={{ pageSize: 10 }} />
      </Card>
    </div>
  );
};

export default PaymentHistory;
